import { getPath, types } from 'mobx-state-tree'
import type { OperationStatus } from '../models/common/OperationStatus'
import { isOversightControl } from './rootStore'

export enum NotificationLevel {
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
    Success = 'success',
}

export const NotificationModel = types.model('NotificationModel')
    .props({
        message: types.string,
        showSyncNote: types.optional(types.boolean, false),
        level: types.enumeration('NotificationLevel', Object.values(NotificationLevel))
    })

export const NotificationStore = types.model('NotificationStore')
    .props({
        notifications: types.array(NotificationModel)
    })
    .volatile(() => ({
        _lastShownObjectForKey: new Map<string, unknown>()
    }))
    .actions((self) => ({
        showNotificationForObject(message: string, level: NotificationLevel, notificationKey: string, object: unknown, showSyncNote = false) {
            if (!isOversightControl()) { showSyncNote = false }
            const lastShownObject = self._lastShownObjectForKey.get(notificationKey)
            if (lastShownObject === object) {
                return
            }

            self._lastShownObjectForKey.set(notificationKey, object)
            self.notifications.push(NotificationModel.create({ message, showSyncNote, level }))
        },
    }))
    .actions((self) => ({
        showOperationStatusNotification(operationStatus: OperationStatus, message: string, showSyncNote = false) {
            const statusTreePath = getPath(operationStatus)
            const notificationLevel =
                operationStatus.isSuccess ? NotificationLevel.Success :
                operationStatus.error ? NotificationLevel.Error :
                NotificationLevel.Info

           self.showNotificationForObject(message, notificationLevel, statusTreePath, operationStatus, showSyncNote)
        },
    }))